import createInstagramFeedWidgets from "./instagram-video-feed-widget";
import createYouTubeFeedWidgets from "./youtube-video-feed-widget";
createInstagramFeedWidgets();
createYouTubeFeedWidgets();
